var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M20,1H16v9.5a.5.5,0,0,1-.5.5.5.5,0,0,1-.325-.121L12,8.159l-3.175,2.72A.5.5,0,0,1,8,10.5V1H4A3,3,0,0,0,1,4V20a3,3,0,0,0,3,3H20a3,3,0,0,0,3-3V4A3,3,0,0,0,20,1Z"}})
}
var staticRenderFns = []

export { render, staticRenderFns }